"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const renderer_1 = require("@react-pdf/renderer");
const borderColor = '#90e5fc';
const styles = renderer_1.StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#e0f3fa',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        fontSize: 12,
        fontStyle: 'bold',
    },
    description: {
        width: '85%',
        textAlign: 'right',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingTop: 5,
        paddingRight: 8,
    },
    total: {
        width: '15%',
        textAlign: 'right',
        paddingTop: 5,
        paddingRight: 8,
    },
});
const InvoiceTableFooter = ({ items }) => {
    const total = items
        .map((item) => item.qty * item.priceTTC)
        .reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    return (react_1.default.createElement(renderer_1.View, { style: styles.row },
        react_1.default.createElement(renderer_1.Text, { style: styles.description }, "TOTAL \u20AC"),
        react_1.default.createElement(renderer_1.Text, { style: styles.total }, Number.parseFloat(total).toFixed(2))));
};
exports.default = InvoiceTableFooter;
